import type { Reservation } from "@b2bportal/lodging-api";
import { dateFormatForAPI, removeTimezone } from "@hopper-b2b/utilities";
import dayjs from "dayjs";

export const getHotelBookingTrackingProperties = (
  reservation: Partial<Reservation> | undefined
) => {
  if (reservation == null) {
    return { properties: {} };
  }

  const { bookedRooms, checkInDate, checkOutDate, createdAt, reservationId } =
    reservation;
  const advance =
    createdAt != null && checkInDate != null
      ? dayjs(checkInDate).diff(removeTimezone(createdAt), "days")
      : undefined;
  const booking_date =
    createdAt != null ? dateFormatForAPI(removeTimezone(createdAt)) : undefined;
  const days_since_booking =
    createdAt != null
      ? dayjs().diff(removeTimezone(createdAt), "days")
      : undefined;

  return {
    properties: {
      advance,
      booking_date,
      check_in_date: checkInDate,
      check_out_date: checkOutDate,
      days_since_booking,
      feature_type: "hotels",
      reservation_id: reservationId,
      room_count: bookedRooms?.reduce((sum, room) => sum + room.count, 0) ?? 1,
    },
  };
};
